module.exports = __webpack_public_path__ + "static/media/inclusive-eye.3cb225e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inclusive-eye.svg
// module id = ./src/assets/images/inclusive-eye.svg
// module chunks = 0